import { render, staticRenderFns } from "./dtlDoc.vue?vue&type=template&id=4d69ba95&scoped=true&"
import script from "./dtlDoc.vue?vue&type=script&lang=js&"
export * from "./dtlDoc.vue?vue&type=script&lang=js&"
import style0 from "./dtlDoc.vue?vue&type=style&index=0&id=4d69ba95&prod&lang=css&"
import style1 from "./dtlDoc.vue?vue&type=style&index=1&id=4d69ba95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69ba95",
  null
  
)

export default component.exports